import apiService from "./ApiService"

class AuthService {
  async login(email, senha) {
    try {
      return await apiService.post('auth', { email, senha })
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async me() {
    try {
      return await apiService.get('auth/me')
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  // SDD 034/033 - troca um token de pre-autenticacao (desafio pos-login com mais de 1 papel
  // de site) ou um token completo ja existente (troca de papel em runtime) por um token
  // completo do vinculo escolhido. O `token` recebido aqui ainda nao esta setado globalmente
  // via setToken()/instance.defaults.headers, entao vai explicito no Authorization desta chamada.
  async selecionarPapel(token, idUsuarioPerfil) {
    try {
      return await apiService.post('auth/selecionar_papel', { idUsuarioPerfil }, { headers: { Authorization: `Bearer ${token}` } })
    } catch (ex) {
      if (ex.response.status === 401 || ex.response.status === 403) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async solicitarCodigoResetSenha(email) {
    try {
      return await apiService.post('auth/resetar_senha/codigo', { email })
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async resetarSenha(token, novaSenha) {
    try {
      return await apiService.post('auth/resetar_senha', { token, novaSenha })
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async alterarSenha(senhaAtual, novaSenha) {
    try {
      return await apiService.post('auth/alterar_senha', { senhaAtual, novaSenha })
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }
}

const authService = new AuthService()
export default authService